export const COMPATIBLE_LLM_MODEL_TYPES = ['text-to-text', 'multimodal-to-text'];
// export const COMPATIBLE_VISION_MODEL_TYPES = []; // DO NOT USE;
